import styled from 'styled-components';

const DateText = styled.div`
  color: #FFF;
  font-family: din, sans-serif;
  font-weight: 500;
  font-size: 32px;
  line-height: 45px;
  text-align: center;
  letter-spacing: -0.408px;
  display: flex;
  flex-direction: column;
  margin-top: 15px;
  flex-shrink: 0;
  @media screen and (min-width: 200px) {
    font-size: 24px;
    line-height: 21px;
  }

  @media screen and (min-width: 400px) {
    font-size: 27px;
    line-height: 38px;
  }

  @media screen and (min-width: 960px) {
    font-size: 32px;
    line-height: 45px;
  }
`;

export default DateText;
